import React, { useState } from 'react'
import styled from 'styled-components'
import { TextArea } from 'grommet'
import {
    FormInputContainer,
    FormInputLabel,
    RequiredSign,
} from '@appearance/styled'
import i18n from '@localization/i18n'

const verificationFunctions = {
    text: () => true,
    number: (value) => !isNaN(value),
}

export default ({
    text,
    comparisonText,
    label,
    placeholder,
    type = 'text',
    onChangeText,
    onDoneEdit,
    required,
    onError,
    containerWidth = 0,
    minHeight,
}) => {
    const [isError, setIsError] = useState(false)
    const verificationFunction = verificationFunctions[type]
    const isComparisonValid = () => !comparisonText || comparisonText == text

    const handleChangeText = (text) => {
        console.log('handleChangeText text', text)
        if (onChangeText) {
            onChangeText(text)
        }
        handleDone(text)
    }

    const isValid = (text) => {
        console.log(
            'isValid (text && text.length > 0)',
            text ? text.length : false
        )
        return (
            (!required || (text && text.length > 0)) &&
            verificationFunction(text) &&
            isComparisonValid()
        )
    }

    const handleDone = (text) => {
        const valid = isValid(text) ? true : false

        if (onDoneEdit) {
            console.log('onDoneEdit - valid ', valid)
            onDoneEdit(valid)
        }
        if (onError) {
            onError(!valid)
        }
        setIsError(!valid)
    }

    return (
        <FormInputContainer width={containerWidth}>
            {label && (
                <FormInputLabel lang={i18n.locale}>
                    {label}
                    {required && <RequiredSign> * </RequiredSign>}
                </FormInputLabel>
            )}
            <StyledTextArea
                value={text}
                type={type}
                placeholder={placeholder}
                onChange={(event) => handleChangeText(event.target.value)}
                isError={isError}
                onBlur={() => handleDone(text)}
                onFocus={() => setIsError(false)}
                minHeight={minHeight}
            />
        </FormInputContainer>
    )
}

const StyledTextArea = styled(TextArea)`
    width: 100%;
    min-height: ${(p) => (p.minHeight ? p.minHeight : 'initial')};
    text-align: right;
    font-weight: 400;
    background-color: #fff;
    border-color: ${(p) => (p.isError ? 'red' : '#ccc')};
`
